( function ( $ ) {
	class Terms {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {
			// Initialize the events.
			const entryFooterLink = $( '.term-plus-icon' );
			this.addEvents( entryFooterLink );

			this.bindInfiniteScrollEvents()

		}

		/**
		 * Bind events for infinite scroll.
		 */
		bindInfiniteScrollEvents() {
			$( document ).on( 'infiniteScrollSectionLoaded', ( event ) => {
				// Get the newly loaded section.
				const { sectionContainer } = event.detail
				const section = $( sectionContainer );

				if ( section.length ) {
					const entryFooterLink = section.find( '.term-plus-icon' );
					this.addEvents( entryFooterLink );
				}
			} );
		}

		/**
		 * Add Events.
		 *
		 * @return {null}
		 */
		addEvents( entryFooterLink ) {
			if ( entryFooterLink.length ) {
				entryFooterLink.on( 'click' , ( event ) => this.showMoreTerms( event ) );
			}
		}

		showMoreTerms( event ) {
			event.preventDefault();

			const targetEl = $( event.target );
			const parentEl = targetEl.parent();
			const termEls = $( parentEl ).children();

			// Show all the terms when plus icon is clicked.
			$( termEls ).removeClass( 'ebayads-hide' );

			// Remove event from plus icon.
			targetEl.off( 'click' );

			// Remove plus icon from DOM.
			targetEl.remove();
		}

	}

	$( document ).ready( function() {
		new Terms();
	} );

} )( jQuery );
